import { render } from "./DiscountGlobal.vue?vue&type=template&id=fcd237a8"
import script from "./DiscountGlobal.vue?vue&type=script&lang=js"
export * from "./DiscountGlobal.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__